import { blurhashToImageCssObject } from '@unpic/placeholder';
export function createBlurhash(image, blurhashEnabled) {
    if (!blurhashEnabled || !image.blurhashEnabled || !image.blurhash) {
        return {};
    }
    try {
        return blurhashToImageCssObject(image.blurhash);
    }
    catch (error) {
        console.warn('Error parsing blurhash:', error);
        return {};
    }
}
